import Component from '@glimmer/component';

const SORT_KEYS = {
  Recipient: 'recipientName',
  'Delivery area': 'deliveryArea.name',
  Carrier: 'carrier.name',
  'Date received': 'createdAt',
  'Date picked up': 'acknowledgedAt',
};

/**
 * @param {Array}               deliveries
 * @param {Function}            onMarkDeliveryAsPickedUpTask
 * @param {Array}               selectedDeliveries
 * @param {Function}            selectAllDeliveries
 * @param {Function}            clearAllSelectedDeliveries
 * @param {Function}            toggleDelivery
 * @param {String}              sortBy
 * @param {String}              sortDirection
 * @param {Function}            setSortBy
 * @param {Function}            setSortDirection
 */
export default class DeliveryList extends Component {
  constructor() {
    super(...arguments);
  }

  get sortBy() {
    return this.args.sortBy || 'Date received';
  }

  get sortDirection() {
    return this.args.sortDirection || 'Most to least recent';
  }

  get isSortAsc() {
    const sortDirection = this.sortDirection;
    const sortAscKeys = ['A to Z', 'Least to most recent'];

    return sortAscKeys.includes(sortDirection);
  }

  get sortedDeliveries() {
    const sortField = SORT_KEYS[this.sortBy];
    const sortedDeliveries = this.args.deliveries?.sortBy(sortField);
    return this.isSortAsc ? sortedDeliveries : sortedDeliveries.reverse();
  }

  get allDeliveriesSelected() {
    const selectedCount = this.args.selectedDeliveries?.length;
    const totalCount = this.sortedDeliveries.length;
    return selectedCount === totalCount;
  }

  get isSelectAllIndeterminate() {
    const selectedCount = this.args.selectedDeliveries?.length;
    const totalCount = this.sortedDeliveries.length;
    return selectedCount > 0 && selectedCount !== totalCount;
  }
}
